import {Component, Input} from '@angular/core';
import {PlaybookGuidelineStatusEnum} from "../plyabbok-guideline-run-tile/playbook-guideline-run-tile.component";
import {CommonModule} from "@angular/common";
import {CoreDirectivesModule} from "../../../../../../../@core/directives/directives";

@Component({
  selector: 'app-guideline-status-icon',
  standalone: true,
  imports: [
      CommonModule,
      CoreDirectivesModule
  ],
  templateUrl: './guideline-status-icon.component.html',
  styleUrl: './guideline-status-icon.component.scss'
})
export class GuidelineStatusIconComponent {
    protected readonly PlaybookGuidelineStatusEnum = PlaybookGuidelineStatusEnum;

    @Input({required:true}) status: PlaybookGuidelineStatusEnum;
    @Input() processing: boolean = false;
}
